'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import { PortalProvider } from '@gorhom/portal'

// lib
import Box from '../kit/box'
import ErrorBoundary from '../error-boundary'
import './global.css'

/* -----------------------------------------------------------------------------
 * AppProviders
 *
 * What the app needs around its routes: the global styles, the portal host
 * that pickers, toasts and drawers render into, and the error boundary. The
 * layout keeps the views @walrus/common's Root drew: a flex view filling
 * #root, where portals land after the app, around two full-size views.
 * -------------------------------------------------------------------------- */

export type AppProvidersProps = {
  children: React.ReactNode
}

function AppProviders({ children }: AppProvidersProps) {
  return (
    <Box style={{ flex: 1 }}>
      <PortalProvider>
        <Box width='100%' height='100%'>
          <Box width='100%' height='100%'>
            <ErrorBoundary>{children}</ErrorBoundary>
          </Box>
        </Box>
      </PortalProvider>
    </Box>
  )
}

export default AppProviders
